import {MODULE_ACTIONS} from "./types";
import {addProcessing, removeProcessing} from "./processingActions";
import {PROC_MODULES_FETCH, PROC_MODULES_UPDATE} from "./index";
import {addError} from "./errorActions";
import {GET, POST, PUT} from "ith-fetch";
import isFunc from 'lodash/isFunction';


const _set = (modules = [], all = false) => ({type: MODULE_ACTIONS.SET, modules, all});
// const _assign = (house_list, house_id) => ({type: MODULE_ACTIONS.SET_HOUSE, house_id, house_list});

export const fetchModules = (force = false, onSuccess) =>
	async (dispatch) => {
		try {
			dispatch(addProcessing(PROC_MODULES_FETCH));
			const result = await GET('/modules');
			dispatch(_set(result.modules, result.all));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_MODULES_FETCH));
		}
	};
export const createModule = (module, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_MODULES_UPDATE));
			const result = await PUT('/modules', module);
			dispatch(_set([result.module]));
			onSuccess && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_MODULES_UPDATE));
		}
	};
export const updateModule = (module, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_MODULES_UPDATE, module.module_id));
			
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_MODULES_UPDATE, module.module_id));
		}
	};
export const adaptModule = (module, onSuccess) =>
	async dispatch => {
		const module_id = module.module_id || module;
		try {
			dispatch(addProcessing(PROC_MODULES_UPDATE, module_id));
			const result = await POST('/modules/adapt/' + module_id);
			dispatch(_set(result.list, false));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_MODULES_UPDATE, module_id));
		}
	};



// WEBPACK FOOTER //
// ./src/actions/moduleActions.js